import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: { marginTop: theme.spacing(4) },
  modalFooter: { display: 'flex', justifyContent: 'space-between', marginTop: '20px' },
}));
